import * as React from 'react';
import * as _ from 'lodash';
import { MediaFrameMediaType, ProductType } from '@wix/wixstores-client-core';
import * as Icons from '../icons/dist';
import { WixMedia } from '../WixMedia';
import classNames from 'classnames';
import s from './OldProductThumbnail.scss';
import { DefaultProductImage } from '../DefaultProductImage/DefaultProductImage';
export var DataHook;
(function (DataHook) {
    DataHook["Wrapper"] = "product-thumbnail-wrapper";
    DataHook["Media"] = "product-thumbnail-media";
    DataHook["Badge"] = "product-badge";
    DataHook["DefaultImage"] = "default-image";
})(DataHook || (DataHook = {}));
export var DEFAULT_DIMENSION = 120;
export var DEFAULT_IMAGE_DEFAULT_SIZE = 50;
var iconsByFileType = function (product, iconSize) {
    var _a;
    var fileType = _.get(product, 'digitalProductFileItems[0].fileType', null);
    var size = iconSize.toString();
    var icons = (_a = {},
        _a[MediaFrameMediaType.SECURE_DOCUMENT] = React.createElement(Icons.DocumentDigitalProductDefaultImage, { size: size }),
        _a[MediaFrameMediaType.SECURE_PICTURE] = React.createElement(Icons.PictureDigitalProductDefaultImage, { size: size }),
        _a[MediaFrameMediaType.SECURE_VIDEO] = React.createElement(Icons.VideoDigitalProductDefaultImage, { size: size }),
        _a[MediaFrameMediaType.SECURE_MUSIC] = React.createElement(Icons.MusicDigitalProductDefaultImage, { size: size }),
        _a[MediaFrameMediaType.SECURE_ARCHIVE] = React.createElement(Icons.DocumentDigitalProductDefaultImage, { size: size }),
        _a);
    return icons[fileType] || icons[MediaFrameMediaType.SECURE_DOCUMENT];
};
var isDigitalProduct = function (product) { return product.productType === ProductType.DIGITAL; };
var defaultImage = function (product, size) {
    if (isDigitalProduct(product)) {
        return iconsByFileType(product, size);
    }
    else {
        return React.createElement(Icons.PhysicalProductDefaultImage, { size: size.toString() });
    }
};
export var OldProductThumbnail = function (_a) {
    var getResizedImageUrl = _a.getResizedImageUrl, product = _a.product, width = _a.width, height = _a.height, defaultImageClassName = _a.defaultImageClassName, defaultImageSize = _a.defaultImageSize, _b = _a.showBadge, showBadge = _b === void 0 ? true : _b, className = _a.className, _c = _a.mediaItemIndex, mediaItemIndex = _c === void 0 ? 0 : _c, _d = _a.hasFixedSize, hasFixedSize = _d === void 0 ? true : _d, imageClassName = _a.imageClassName, _e = _a.alwaysShowBadge, alwaysShowBadge = _e === void 0 ? false : _e, _f = _a.withSrcSet, withSrcSet = _f === void 0 ? true : _f, onImageLoad = _a.onImageLoad, digitalProductBadgeTranslationKey = _a.digitalProductBadgeTranslationKey, _g = _a.useNewDefaultProductImage, useNewDefaultProductImage = _g === void 0 ? false : _g, _h = _a.useDynamicDefaultImageSize, useDynamicDefaultImageSize = _h === void 0 ? false : _h;
    var mediaItem = product.media.length > mediaItemIndex && product.media[mediaItemIndex];
    var aspectRatio = mediaItem.width / mediaItem.height;
    var alt = product.media.altText || product.name;
    var imageWidth = width || (height ? aspectRatio * height : null) || DEFAULT_DIMENSION;
    var imageHeight = height || (width ? width / aspectRatio : null) || DEFAULT_DIMENSION;
    var iconSize = defaultImageSize || DEFAULT_IMAGE_DEFAULT_SIZE;
    var style = { width: imageWidth, height: imageHeight };
    var renderBadge = function () {
        return showBadge &&
            isDigitalProduct(product) && (React.createElement("div", { className: s.productBadge, "data-hook": DataHook.Badge, "aria-label": digitalProductBadgeTranslationKey },
            React.createElement(Icons.DigitalProductBadge, null)));
    };
    if (mediaItem) {
        return (React.createElement("div", { className: classNames(s.productImage, className), "data-hook": DataHook.Wrapper },
            React.createElement(WixMedia, { "data-hook": DataHook.Media, wixMediaFetcher: { getResizedImageUrl: getResizedImageUrl }, mediaItem: mediaItem, widthDimension: imageWidth || DEFAULT_DIMENSION, heightDimension: imageHeight || DEFAULT_DIMENSION, alt: alt, hasFixedSize: hasFixedSize, className: imageClassName, withSrcSet: withSrcSet, onLoad: onImageLoad }),
            renderBadge()));
    }
    else if (useNewDefaultProductImage) {
        return (React.createElement(React.Fragment, null,
            React.createElement(DefaultProductImage, { className: classNames(s.defaultImage, className, defaultImageClassName), imageSize: defaultImageSize, imageContainerDimensions: style, dataHook: DataHook.DefaultImage, isDynamicSize: useDynamicDefaultImageSize }),
            alwaysShowBadge && renderBadge()));
    }
    else {
        return (React.createElement("div", { "data-hook": DataHook.DefaultImage, className: classNames(s.defaultImage, className, defaultImageClassName), style: style },
            defaultImage(product, iconSize),
            alwaysShowBadge && renderBadge()));
    }
};
OldProductThumbnail.displayName = 'ProductThumbnail';
//# sourceMappingURL=OldProductThumbnail.js.map